"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportCriticalActions = exports.ExportCriticalActions = exports.ExportCriticalActionsActionTypes = exports.CriticalActionsApiActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var CriticalActionsApiActionTypes = (0, _namespacedKeyMirror.default)({
  EXPORT: null
}, 'criticalActions');
exports.CriticalActionsApiActionTypes = CriticalActionsApiActionTypes;
var ExportCriticalActionsActionTypes = (0, _actions.createRequestTypes)(CriticalActionsApiActionTypes.EXPORT);
exports.ExportCriticalActionsActionTypes = ExportCriticalActionsActionTypes;
var ExportCriticalActions = (0, _actions.createRequestActions)(ExportCriticalActionsActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ExportCriticalActionsActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('accountdefaults.security.criticalActionsExport.notifications.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ExportCriticalActionsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.criticalActionsExport.notifications.failure')));
  }
});
exports.ExportCriticalActions = ExportCriticalActions;
var exportCriticalActions = (0, _fluxActions.createAction)(CriticalActionsApiActionTypes.EXPORT);
exports.exportCriticalActions = exportCriticalActions;